import { FC } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import V2PieChart from '@/common/components/Charts/V2PieChart';

/**
 * @Description 有无孩子比例
 */
const HasChildRatio: FC<{ data: any, resizable?: boolean }> = ({
  data,
  resizable = true,
}) => {
  return (
    <div className={cs(styles.chartWrapper, styles.pieChart, 'pd-16')}>
      <div className='fs-14 c-222 bold'>有无子女</div>
      <V2PieChart
        title=''
        type='circle'
        resizable={resizable}
        seriesData={[{
          data: data,
          unit: '%',
          animation: false,
          radius: ['46%', '58%'],
          center: ['28%', '52%']
        }]}
        height={260}
      />
    </div>
  );
};

export default HasChildRatio;
